import React from "react";
import FontAwesome from "react-fontawesome";
import autoBind from "react-autobind";
import PlayerCheckbox from "./PlayerCheckbox";
import _ from "lodash";

import { markdownToHtml } from "../../utils/markupUtils";
import withPlayerItemHoc from "./PlayerItemHoc";
import { getUrlForValue } from "../../actions/drive";
import { getSelectedActivityId } from "../../actions/playerActions";
import DoneButton from "./DoneButton";

/*
	 Generic read-only version of a player component 
 */
class PlayerItem extends React.PureComponent {

	constructor(props) {
		super(props);
		this.readOnly = false;
		this.showModeVideoRef = React.createRef();
		autoBind(this);
	}

	onSubmit(event) {
		if (this.props.onSubmit) {
			const checked = this.props.item && this.props.item.labelOnly ? true : event.target.checked;
			console.log("SUBMIT", checked);
			this.props.onSubmit(checked);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.selected === false && this.props.selected === true && this.props.showMode) {
			let video = _.get(this.showModeVideoRef, "current.video")
			if (!_.isUndefined(video) && video !== null) {
				video.pause();
				video.seek(0);
			}
		}
	}

	render() {
		if (this.props.showMode !== true) {
			if (this.props.readOnly) {
				return this.renderReadOnly();
			} else {
				return this.renderEditable();
			}
		} else {
			return this.renderShowMode();
		}
	}

	renderReadOnly() {
		const { item, getImage, getVideo, getPdf, selected } = this.props;

		let check;
		if (!(this.props.hasOwnProperty("showMode") && this.props.showMode) && !(this.props.item.labelOnly)) {
			if (item.checked) {
				check = <FontAwesome fixedWidth={true} style={{ fontSize: "32px", width: "32px", height: "32px", margin: 10 }} name="check-square-o" />;
			} else {
				check = <FontAwesome fixedWidth={true} style={{ fontSize: "32px", width: "32px", height: "32px", margin: 10 }} name="square-o" />;
			}
		}

		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		return (
			<div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
				<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
					{check}
					<div style={{ width: "100%", overflowX: "auto" }}>
						<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { readOnlyLinks: true })} />
						<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { readOnlyLinks: true })} />
						{getImage()}
						{getVideo()}
						{getPdf()}
						{this.getImageComponent()}
					</div>
				</div>
				{item && item.labelOnly && selected && <DoneButton onSubmit={this.onSubmit} />}
			</div>
		);
	}

	renderEditable() {
		const { item, getImage, getVideo, getPdf, selected, listIndex, sectionIndex, itemIndex, disabled } = this.props;

		let check = <PlayerCheckbox className="player-item-checkbox-large" id={"player-check-item-" + this.props.getActivityItemPath("-")} disabled={disabled} checked={item.checked} item={item} onChange={this.onSubmit} />;
		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		return (
			<div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
				<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
					{check}
					<div style={{ width: "100%", overflowX: "auto" }}>
						<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { listIndex, sectionIndex, itemIndex })} />
						<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { listIndex, sectionIndex, itemIndex })} />
						{getImage()}
						{getVideo()}
						{getPdf()}
						{this.getImageComponent()}
					</div>
				</div>
				<div>
					{item && item.labelOnly && selected && !disabled && <DoneButton onSubmit={this.onSubmit} />}
				</div>
			</div>
		);
	}

	renderShowMode() {
		const { item, showModeTextAlign: _showModeTextAlign } = this.props;
		// console.log("Deternine background image", this.props);
		let backgroundImage;
		if (item.backgroundImage) {
			const url = getUrlForValue(item.backgroundImage, getSelectedActivityId());
			backgroundImage = `url(${url})`;
		}

		let mediaItem;

		let image = this.props.getImageShowMode();
		let video = this.props.getVideoShowMode(this.showModeVideoRef);

		if (image) {
			mediaItem = image;
		} else if (video) {
			mediaItem = video;
		}

		const hasTextContent = (item.label1 && !_.isEmpty(item.label1)) || (item.label2 && !_.isEmpty(item.label2))

		const { showModeTextAlign } = item;

		let align = "";
		if (showModeTextAlign || _showModeTextAlign) {

			const targetShowModeTextAlign = showModeTextAlign ? showModeTextAlign : _showModeTextAlign;

			align = " " + targetShowModeTextAlign.split("-").join(" ");
		}

		return (<div style={{
			display: "flex", flexDirection: "column", width: "100%", height: "100%", backgroundImage: backgroundImage, backgroundPosition: "center", backgroundSize: "cover", backgroundRepeat: "noRepeat"
		}}>
			<div style={{ display: "flex", width: "100%", height: "100%", padding: "20px 50px 40px 50px", boxSizing: "border-box" }}>
				<div className="player-show-mode-view" style={{ width: "100%", height: "100%", overflow: "none", display: "flex", position: "relative" }}>

					{hasTextContent && <div className={`player-show-mode-label-item-container${align}`}>
						<h2 dangerouslySetInnerHTML={markdownToHtml(item.label1)} />
						<h3 dangerouslySetInnerHTML={markdownToHtml(item.label2)} />
					</div>}
					{mediaItem && <div className="player-show-mode-media-item-container">
						<div>{mediaItem}</div>
					</div>}
				</div>
			</div>
		</div>);
	}

	getImageComponent() {
		const item = this.props.item;

		let imageComponent;
		if (item.hasOwnProperty("sketchPadImage") && item.sketchPadImage !== null && item.sketchPadImage !== "") {
			const imgUrl = "<p><b>Sketch</b><br/><a href='" + item.sketchPadImage + "' target='blank'><img style='width: 30%; border: 1px solid #eeeeee' src='" + item.sketchPadImage + "' /></a></p>";
			imageComponent =
				<div dangerouslySetInnerHTML={markdownToHtml(imgUrl)} />;
		}
		return imageComponent;
	}
}

export default withPlayerItemHoc(PlayerItem);